// eslint-disable-next-line import/prefer-default-export -- follow nav messages file pattern
export const invertedMessages = {
  'Verify Your Identity': 'Nav.MfaPrompt.PromptModalMenuTitle',
  'Select one of the methods to continue.':
    'Nav.MfaPrompt.PromptModalMenuSubTitle',
  'Enter Your Passcode': 'Nav.MfaPrompt.PromptModalFormTitle',
  'Open your authenticator and enter the passcode to verify your identity.':
    'Nav.MfaPrompt.PromptModalFormSubTitle',
  'SMS Passcodes': 'Nav.MfaPrompt.PromptSmsFormTitle',
  'Email Passcodes': 'Nav.MfaPrompt.PromptEmailFormTitle',
  'Timed Passcodes': 'Nav.MfaPrompt.PromptTotpFormTitle',
  'One-time passcodes will be sent to your mobile device.':
    'Nav.MfaPrompt.PromptSmsFormDescription',
  'One-time passcodes will be sent to your email address.':
    'Nav.MfaPrompt.PromptEmailFormDescription',
  'Enter time-based one-time passcodes (TOTP) via an authenticator.':
    'Nav.MfaPrompt.PrompttOtpFormDescription',
  Next: 'Nav.MfaPrompt.NextButton',
  Back: 'Nav.MfaPrompt.BackButton',
  'Enter the 6-digit code': 'Nav.MfaPrompt.PlaceHolder',
  '6-Digit Code': 'Nav.MfaPrompt.DigitCode',
  'Please enter a valid code': 'Nav.MfaPrompt.EnterValidCode',
  'Loading your authentication methods...': 'Nav.MfaPrompt.Loading',
  "Sorry, we're having trouble loading the content. Please try reloading the page, or check your internet connection. If the issue persists, contact support.":
    'Nav.MfaPrompt.Error',
  'Third-party SSO': 'Nav.MfaPrompt.PromptIdaasFormTitle',
  'Use your SSO account to verify your identity.':
    'Nav.MfaPrompt.PromptTotpFormDescription',
  'A popup has been opened to verify your identity...':
    'Nav.MfaPrompt.IdaasBridgeMessage',
  'Please wait...': 'Nav.MfaPrompt.IdaasCallbackMessage',
  Reload: 'Nav.MfaPrompt.ReloadButton',
} as const;

export const messages: Record<string, string> = {} as const;
